// FETCH ALL PROPERTIES FROM TEAM MASTER
export const FETCH_KNITTING_INWARD_REQUEST = 'FETCH_KNITTING_INWARD_REQUEST';
export const FETCH_KNITTING_INWARD_SUCCESS = 'FETCH_KNITTING_INWARD_SUCCESS';
export const FETCH_KNITTING_INWARD_FAILURE = 'FETCH_KNITTING_INWARD_FAILURE';

// CREATE PROPERTIES FOR TEAM MASTER
export const CREATE_KNITTING_INWARD_REQUEST = 'CREATE_KNITTING_INWARD_REQUEST';
export const CREATE_KNITTING_INWARD_SUCCESS = 'CREATE_KNITTING_INWARD_SUCCESS';
export const CREATE_KNITTING_INWARD_FAILURE = 'CREATE_KNITTING_INWARD_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_KNITTING_INWARD = 'CREATE_USER_FORM_KNITTING_INWARD';

// UPDATE PROPERTIES FOR TEAM MASTER
export const UPDATE_KNITTING_INWARD_REQUEST = 'UPDATE_KNITTING_INWARD_REQUEST';
export const UPDATE_KNITTING_INWARD_SUCCESS = 'UPDATE_KNITTING_INWARD_SUCCESS';
export const UPDATE_KNITTING_INWARD_FAILURE = 'UPDATE_KNITTING_INWARD_FAILURE';

// FETCH SINGLE TEAM
export const FETCH_SINGLE_KNITTING_INWARD_REQUEST = 'FETCH_SINGLE_KNITTING_INWARD_REQUEST';
export const FETCH_SINGLE_KNITTING_INWARD_SUCCESS = 'FETCH_SINGLE_KNITTING_INWARD_SUCCESS';
export const FETCH_SINGLE_KNITTING_INWARD_FAILURE = 'FETCH_SINGLE_KNITTING_INWARD_FAILURE';

// DELETE PROPERTIES FOR TEAM MASTER
export const DELETE_KNITTING_INWARD_REQUEST = 'DELETE_KNITTING_INWARD_REQUEST';
export const DELETE_KNITTING_INWARD_SUCCESS = 'DELETE_KNITTING_INWARD_SUCCESS';
export const DELETE_KNITTING_INWARD_FAILURE = 'DELETE_KNITTING_INWARD_FAILURE';

export const FETCH_PENDING_KNITTING_PO_IN_INWARD_REQUEST = 'FETCH_PENDING_KNITTING_PO_IN_INWARD_REQUEST';
export const FETCH_PENDING_KNITTING_PO_IN_INWARD_SUCCESS = 'FETCH_PENDING_KNITTING_PO_IN_INWARD_SUCCESS';
export const FETCH_PENDING_KNITTING_PO_IN_INWARD_FAILURE = 'FETCH_PENDING_KNITTING_PO_IN_INWARD_FAILURE';

// USERFORM RESET

export const KNITTING_INWARD_USERFORM_RESET = 'KNITTING_INWARD_USERFORM_RESET';

// navigate to unit component
export const NAVIGATE_KNITTING_INWARD_DETAILS = 'NAVIGATE_KNITTING_INWARD_DETAILS';
// navigate to company component
export const NAVIGATE_KNITTING_INWARD = 'NAVIGATE_KNITTING_INWARD';
export const SET_UNIT_NAME_KNITTING_INWARD = 'SET_UNIT_NAME_KNITTING_INWARD';
export const SET_START_DATE_KNITTING_INWARD = 'SET_START_DATE_KNITTING_INWARD';
export const SET_END_DATE_KNITTING_INWARD = 'SET_END_DATE_KNITTING_INWARD';

export const SET_ACTIVE_KEY_KNITTING_INWARD = 'SET_ACTIVE_KEY_KNITTING_INWARD';
export const RESET_FORM_DATA_WITHOUT_KNITTING_INWARD_ID = 'RESET_FORM_DATA_WITHOUT_KNITTING_INWARD_ID';
